import { Filter } from '../interfaces/filter.interface';

export const parseAssetsFilters = (string: string): Filter[] => {
  if (!string) return;
  try {
    return JSON.parse(string);
  } catch {}
};
